import { api } from "./base";

export const postNewsletter = async (newsletterEmail) => {
  const res = await api.post("/newsletter", {
    newsletterEmail,
  });
  return res;
};
